(function() {
  const content = document.getElementById('foldableContent');
  const toggle = document.getElementById('foldableToggle');
  const label = document.getElementById('toggleLabel');
  const arrow = document.getElementById('toggleArrow');

  let expanded = false;

  function updateUI() {
    if (expanded) {
      content.classList.add('expanded');
      label.innerText = 'Less';
      arrow.innerText = '▲';
    } else {
      content.classList.remove('expanded');
      label.innerText = 'More';
      arrow.innerText = '▼';
    }
  }

  updateUI();

  toggle.addEventListener('click', function(e) {
    e.stopPropagation();
    expanded = !expanded;
    updateUI();
  });
})();

document.addEventListener('DOMContentLoaded', function() {
  const trigger = document.getElementById('hover-trigger-3');
  const hoverImage = document.getElementById('hover-image-3');

  if (!trigger || !hoverImage) return;

  function isMobileDevice() {
    return window.innerWidth <= 768;
  }

  function handleMobileClick() {
    if (!isMobileDevice()) return;
    hoverImage.classList.toggle('active');
  }

  function handleDocumentClick(e) {
    if (!isMobileDevice()) return;
    if (trigger && !trigger.contains(e.target)) {
      hoverImage.classList.remove('active');
    }
  }

  trigger.addEventListener('click', handleMobileClick);
  document.addEventListener('click', handleDocumentClick);

  trigger.addEventListener('click', function(e) {
    if (isMobileDevice()) {
      e.stopPropagation();
    }
  });
});
